require("classlist-polyfill");
require("raf").polyfill();



// WEBPACK FOOTER //
// ./src/app/utils/polyfills/index.js